import { SlopeKeycloak, type SlopeKeycloakOptions } from './SlopeKeycloak.js';

// Create a default instance factory
export function createSlopeKeycloak(options: SlopeKeycloakOptions): SlopeKeycloak {
  return new SlopeKeycloak(options);
}
